<template>
  <div class="view">
    <div class="title">
      <i class="goback el-icon-arrow-left" @click="goback"></i>编辑外部合伙人
    </div>
    <div class="content">
      <div class="set_wrap">
        <el-form ref="form" :rules="rules" :model="formdata" label-width="220px">
          <el-form-item label="真实姓名" prop="name">
            <el-input type="text" v-model="formdata.name" placeholder="请输入名称" class="w340"></el-input>
          </el-form-item>
          <el-form-item label="联系方式" prop="tel">
            <el-input type="text" v-model="formdata.tel" placeholder="请输入联系方式" class="w340"></el-input>
          </el-form-item>
          <el-form-item label="充值金额" prop="balance">
            <el-input type="text" v-model="formdata.balance" placeholder="请填写金额" class="w340"></el-input>
          </el-form-item>
          <el-form-item label="是否可消费" prop="is_discount">
          <el-radio-group v-model="is_discount">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
          <el-form-item label="银行卡号" prop="bank_card">
            <el-input type="text" v-model="formdata.bank_card" placeholder="请填写卡号" class="w340"></el-input>
          </el-form-item>
           <el-form-item label="户名" prop="bank_username">
            <el-input type="text" v-model="formdata.bank_username" placeholder="请填写户名" class="w340"></el-input>
          </el-form-item>
           <el-form-item label="开户行" prop="bank_name">
            <el-input type="text" v-model="formdata.bank_name" placeholder="请填写开户行" class="w340"></el-input>
          </el-form-item>
          <el-form-item label="到期时间" prop="expire_time">
            <el-date-picker v-model="formdata.expire_time" type="date" placeholder="请选择到期时间"> </el-date-picker>
          </el-form-item>
          <el-form-item label="专属管家">
            <div v-if="is_edit==1">
              <el-select v-model="formdata.keeper_id" placeholder="请选择" @change="changeEmployee">
                <el-option
                        v-for="item in tagList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div v-else>{{role_name?role_name:'-'}}</div>
          </el-form-item>
          <el-form-item label="备注" prop="remark">
            <el-input type="textarea" v-model="formdata.remark" placeholder="请输入" class="w340"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="save('form')">保存</el-button>
            <el-button @click="goback">返回</el-button>
          </el-form-item>
          
        </el-form>
      </div>
    </div>
    <chooseDepDialog
            :visible.sync="choosedepdialog"
            v-if="choosedepdialog"
            @choosedepsucess="choosedepsucess"
    ></chooseDepDialog>
  </div>
</template>
<script>
  import api from "@/api.js";
  import chooseDepDialog from "@/components/dialog/chooseDepDialog.vue";
 

  export default {
    name: "extpartnerEdit",
    components: {
      chooseDepDialog,
    },
    data() {
      return {
        data_: {token: sessionStorage.getItem("token")},
        formdata: {
          partner_id: "",
          name: "",
          tel: "",
          eid: "",
          balance: "",
          bank_card: "",
          bank_username: "",
          bank_name: "",
          is_discount: "",
          expire_time: "",
          remark: "",
          keeper_id: "",
        },
        lock: true,
        // fileList: [],
        rules: {
          name: [{required: true, message: "请输入姓名", trigger: "blur"}],
          tel: [{required: true, message: "请输入联系方式", trigger: "blur"}],
          balance: [{required: true, message: "请输入金额", trigger: "blur"}],
          bank_card: [{required: true, message: "请输入银行卡号", trigger: "blur"}],
          bank_username: [
            {required: true, message: "请输入户名", trigger: "blur"}
          ],
          bank_name: [
            {required: true, message: "请输入开户行", trigger: "blur"}
          ],
          expire_time: [
            {required: true, message: "请输入到期时间", trigger: "blur"}
          ]
        },
        is_edit: null,
      };
    },
    created() {
      this.queryemployeedetail();
    },
    methods: {
      // 查询员工详情
      queryemployeedetail() {
        // is_edit	1可修改 部门 企业角色
        this.axios
            .post(api.partner_edit, {eid: this.$route.query.partnerid})
            .then(response => {
              if (response.data.code == 0) {
                for (let i in this.formdata) {
                  if (i === "keeper_id" && !response.data.info[i]) {
                    this.formdata.keeper_id = "";
                  } else {
                    this.formdata[i] = response.data.info[i];
                  }
                }
                ;
                // "is_edit":"是否可以修改角色(0不可修改、1可以修改)",
                this.is_edit = response.data.info.is_edit;
                // this.fileList = [{name: "user", url: response.data.info.pic}];
                this.role_name = response.data.info.role;
                this.is_edit = response.data.info.is_edit;
                for (let i in response.data.info.department) {
                  this.partmentListName.push(response.data.info.department[i].name);
                  this.partmentListId.push(response.data.info.department[i].id);
                }
                ; 
              } else {
              }
            })
            .catch(response => {
            });
      },
      
      // 选择部门
      choosedep() {
        this.choosedepdialog = true;
      },
      choosedepsucess(val) {
        // partmentListName:[],
        // partmentListId:[],
        // this.formdata.department = val.name;
        // this.formdata.depart_id = val.id;
        if (this.partmentListId.indexOf(val.id) !== -1) {
          this.$message.error('部门已经存在');
          return
        }
        this.partmentListName.push(val.name);
        this.partmentListId.push(val.id);
      },
      // 保存
      save(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            if (this.lock) {
              this.lock = false;
              this.submitsave();
            }
          } else {
            return false;
          }
        });
      },
      // 提交保存
      submitsave() {
        if (this.partmentListId.length === 0) {
          this.$message.error('请选择相应部门');
          return
        }
        else{
          
        }
        this.formdata.depart_id = this.partmentListId.join(',');
        this.formdata.eid = this.$route.query.partnerid;
        this.axios
            .post(api.partner_edit, this.formdata)
            .then(response => {
              this.lock = true;
              if (response.data.code == 0) {
                this.$message({
                  message: "编辑成功",
                  type: "success"
                });
              } 
            })
            .catch(response => {
              this.lock = true;
            });
      },
      goback() {
        this.$router.go(-1);
      },
      closePartmentFn(index) {
        this.partmentListName.splice(index, 1);
        this.partmentListId.splice(index, 1);
      },
    }
  };
</script>
